<!-- The dark subheader sits flush on the page; the light one keeps a line under it. -->
<div
  [class.border-b]="!darkMode()"
  class="resource-header flex flex-row items-center h-full justify-between py-1 px-6 border-neutral-50 border-solid"
>
  <div class="flex flex-row items-center gap-x-4">
    @if (breadcrumbs()?.length) {
      <flx-breadcrumbs
        [model]="breadcrumbs()"
        [ngClass]="darkMode() ? 'text-white' : 'text-black'"
        (itemClick)="trackBreadcrumbClick($event)"
        class="flx-resource-breadcrumbs text-xs"
      >
      </flx-breadcrumbs>
    }

    @if (errorBadgeCount() > 0) {
      <flx-severity-marker
        [count]="errorBadgeCount()"
        class="-ml-2"
        interactive
        severity="ERROR"
        data-testid="resource-header-error-badge"
      />
    }
  </div>

  <ng-content select="[resourceHeaderCenterContent]"></ng-content>

  <ng-content select="[resourceHeaderRightContent]"></ng-content>
</div>
